import * as React from 'react';
import { Link } from 'react-router-dom';
import { MdEqualizer as MdCharts, MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { routeConstants } from 'app/routes/route-constants';
import { When } from './when';
import { MenuAccess } from '../../../types';
import styles from '../mobile-nav.scss';

interface Props {
  translation: any;
  menuAccess: MenuAccess;
  onItemClick: () => void;
}

export const ToolsImportSetsMenuItem = ({ translation, menuAccess, onItemClick }: Props) => (
  <When condition={menuAccess.importSetsAdministration}>
    <li>
      <input type="checkbox" id="mobile-admin-import-sets" />
      <div className={`${styles.dropdownButton} list-group-item`}>
        <MdCharts className={styles.navItemIcon} />
        <span className={`${styles.navItemText} ${styles.small}`}>
          {translation.code_mapping_administration}
        </span>
        <label className={styles.dropdownLabel} htmlFor="mobile-admin-import-sets">
          <MdKeyboardArrowDown className={styles.down} />
          <MdKeyboardArrowUp className={styles.up} />
        </label>
      </div>

      <ul className={styles.subMenu}>
        <li className={styles.child} onClick={onItemClick}>
          <Link to={routeConstants.importSetList} className="list-group-item">
            <span className={styles.navItemText}>
              {translation.manage_import_sets}
            </span>
          </Link>
        </li>
        <li className={styles.child} onClick={onItemClick}>
          <Link to={routeConstants.importMappings} className="list-group-item">
            <span className={styles.navItemText}>
              {translation.manage_code_mappings}
            </span>
          </Link>
        </li>
      </ul>
    </li>
  </When>
);
